import React, {createContext, useContext, useState} from 'react';
import {omit} from "lodash";
import showTypeToParamName from "../utils/tecRmi/showTypeToParamName";

const TecRmiContext = createContext(null);

export const TecRmiProvider = (props) => {
  const [workTimeMultiplier, setWorkTimeMultiplier] = useState(1)
  const [modulesData, setModulesData] = useState({})
  const [printData, setPrintData] = useState({})

  const getApiPrimaryParams = () => ({
    typeId: props.typeId,
    [showTypeToParamName(props.showType)]: true,
  })

  return (
    <TecRmiContext.Provider
      value={{
        ...omit(props, ['children', 'typeId']),
        typeId: parseInt(props.typeId),
        showType: props.showType,
        getApiPrimaryParams,
        workTimeMultiplier,
        setWorkTimeMultiplier,
        modulesData,
        getModuleData: moduleId => modulesData[moduleId],
        setModuleData: (moduleId, data) => {
          setModulesData({
            ...modulesData,
            [moduleId]: data,
          })
        },
        printData,
        setPrintData: (path, params) => setPrintData({path, params}),
        unsetPrintData: () => setPrintData({}),
      }}
    >
      {props.children}
    </TecRmiContext.Provider>
  );
};

export const useTecRmi = () => {
  return useContext(TecRmiContext);
};